import React from 'react';
import styles from './styles';
import ContentItem from '../../../OverviewContainer/EditableField';
import dataLogic from '../../Hooks/DataLogic'
import FlyerSection from "../FlyerSection";
import {ImageUploader, ImageDisplay, StagingImage, Button, removeStagingMedia} from '@xpertdox_js/xdcomponents';
import axiosConfig from '../../../../config/axios.config';
import unStageMedia from '../../Hooks/unStageMedia';
import PiSection from '../PiSection';
import NonEditingDisplay from '../PiSection/NonEditingDisplay';
import HeaderObj from '../../../TrialUI/dataTableSettings';
import { trackActivity } from '../../../../utils/activityTracker'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'
import MsgBanner from '../../../msgBanner';

const PatientView = props => {
    const headerObj = HeaderObj.headers;
    const { user } = React.useContext(UserContext)
    const { contextInstance } = React.useContext(InstanceContext)
    const [stagingFlyer, setStagingFlyer] = React.useState(props.diff.flyer || null);
    const [addedPIs, setAddedPIs] = React.useState(props.data.investigators ? props.data.investigators : props.diff.investigators ? props.diff.investigators : []);
    const handleAddPi = (val) => {
      // console.log(val)
      setAddedPIs(val);
    }

    const handleActivityLogUpdate = (_id) => {
      trackActivity({
        body: {
          _id,
          instance: contextInstance || user.instance,
          user: user.id
        }
      })
    }

    const content = [
      {
        title: 'Custom Title',
        diffProperty: 'customTitle',
        value: props.data.customTitle || props.data.title,
        editedLogs: props.editedLogs ? props.editedLogs['customTitle'] : false,
        formSettings: [{
            defaultValue: dataLogic.getDefaultValue(props.data.default, 'brief_title'),
            type: 'text',
            value: props.diff.customTitle || props.data.customTitle || props.data.title,
        }],
        tooltip: headerObj.customTitle.tip
      },
      {
        title: 'Simplified Description',
        diffProperty: 'customDescription',
        editedLogs: props.editedLogs ? props.editedLogs['customDescription'] : false,
        value: dataLogic.returnValue(props.data, 'customDescription'),
        formSettings: [{
            type: 'textarea',
            defaultValue: dataLogic.getDefaultValue(props.data.default, 'custom', 'brief'),
            value: props.diff.customDescription || dataLogic.returnValue(props.data, 'customDescription'),
            options: {submitOnEnter: true}
        }],
        tooltip: headerObj.customDescription.tip
      },
      {
        title: 'Simplified Primary Outcome',
        diffProperty: 'customPrimaryOutcome',
        editedLogs: props.editedLogs ? props.editedLogs['customPrimaryOutcome'] : false,
        value: dataLogic.returnValue(props.data, 'customPrimaryOutcome'),
        formSettings: [{
            type: 'textarea',
            defaultValue: dataLogic.getDefaultValue(props.data.default, 'custom', 'outcomes'),
            value: props.diff.customPrimaryOutcome || dataLogic.returnValue(props.data, 'customPrimaryOutcome'),
            options: {submitOnEnter: true}
        }],
        tooltip: headerObj.simplifiedPrimaryOutcome.tip
      },
      {
        title: 'Simplified Eligibility Criteria',
        diffProperty: 'customEligibilityCriteria',
        editedLogs: props.editedLogs ? props.editedLogs['customEligibilityCriteria'] : false,
        value: dataLogic.returnValue(props.data, 'customEligibilityCriteria'),
        formSettings: [{
            type: 'textarea',
          defaultValue: dataLogic.getDefaultValue(props.data.default, 'custom', 'eligibility'),
            value: props.diff.customEligibilityCriteria || dataLogic.returnValue(props.data, 'customEligibilityCriteria'),
            options: {submitOnEnter: true}
        }],
        tooltip: headerObj.studyPopulation.tip
      },
      {
        title: 'Extra Information',
        diffProperty: 'extraInfo',
        editedLogs: props.editedLogs ? props.editedLogs['extraInfo'] : false,
        value: dataLogic.returnValue(props.data, 'extraInfo'),
        formSettings: [{
            type: 'textarea',
            value: props.diff.extraInfo || dataLogic.returnValue(props.data, 'extraInfo'),
            options: {submitOnEnter: true}
        }],
        tooltip: headerObj.extraInfo.tip
      }
    ]


    return(
      <div style={styles.container}>
        <MsgBanner type='editField' removable user={props.user}/>
        <div style={styles.editPanel}>
          {content.map((settings, i) => <ContentItem
              setValue={props.setDiff}
              key={i}
              index={i}
              length={content.length - 1}
              diff={props.diff[settings.diffProperty]}
              settings={settings}
              zIndex={content.length - i}
              width={props.width}
            />
          )}
        </div>
      </div>
    )
}

export default PatientView;
